import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { any, async, fromJSX, loadedAsyncState, nothing, onlyIf } from "widgets-for-react";
import { features } from "../../features";
import { buildGoogleTranslateElement, gtCallBackName, gtTargetElementId, loadGoogleTranslate } from "./GoogleTranslate";
export const GoogleTranslateEngine = (props)=>features().automatedTranslations == 'off' ? /*#__PURE__*/ _jsx(_Fragment, {}) : GoogleTranslateWidget(props.state.googleTranslate).run((googleTranslate)=>props.setState((prevState)=>({
                ...prevState,
                googleTranslate
            })));
const GoogleTranslateWidget = (props)=>any({
        key: `gt`
    })([
        fromJSX((_)=>/*#__PURE__*/ _jsx("div", {
                id: gtTargetElementId
            }, "gt-element")),
        onlyIf(props.dropdown.kind == 'unloaded', fromJSX((setState)=>{
            window[gtCallBackName] = ()=>setState((s0)=>({
                        ...s0,
                        dropdown: loadedAsyncState(buildGoogleTranslateElement())
                    }));
            loadGoogleTranslate();
            return /*#__PURE__*/ _jsx(React.Fragment, {}, "gt-onlyIf");
        })),
        // Manage async state updates
        async(nothing, {
            key: 'googleTranslateLoader'
        })(props.dropdown).map((resultUpdater)=>(s0)=>{
                const selector = resultUpdater(s0.dropdown);
                return {
                    ...s0,
                    selector
                };
            })
    ]).map((a)=>a(props));
